"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SystemMenuList = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const ui_1 = require("@completeanatomy/ui");
const desktop_1 = require("./desktop");
const mobile_1 = require("./mobile");
const deviceBreakpointSize = 899;
function SystemMenuList(props) {
    const isLower = (0, ui_1.useScreenBreakpoint)(deviceBreakpointSize);
    return isLower ? ((0, jsx_runtime_1.jsx)(mobile_1.MobileSystemMenuList, Object.assign({}, props, { "data-e2e": 'SystemMenuList_MobileSystemMenuList' }))) : ((0, jsx_runtime_1.jsx)(desktop_1.DesktopSystemMenuList, Object.assign({}, props, { "data-e2e": 'SystemMenuList_DesktopSystemMenuList' })));
}
exports.SystemMenuList = SystemMenuList;
